import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { AquariusButtonGroup } from "@smartrr/shared/customerPortal/components/AquariusButtonGroup";
import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";
import { toast } from "react-toastify";

import { CustomerAction } from "@customer-app/state/typedCustomerRedux";
import { useSmartrrCustomerDispatch } from "@customer-app/state/typedCustomerReduxHooks";

import { RedeemVariantOTPProps } from "./RedeemVariantOTP";
import { OrderVariantImage } from "../../../../Subscription/constants";
import { LoyaltyStoreAccess } from "../../../store";

interface RedeemVariantDeliveryProps extends RedeemVariantOTPProps {
  upcomingOrder: PurchaseStateAndDelivery;
  purchasableName: string;
}
export const RedeemVariantDelivery = ({
  upcomingOrder,
  variant,
  purchasableName,
  closeVariantModal,
  shopifyVariant,
}: RedeemVariantDeliveryProps) => {
  const actions = LoyaltyStoreAccess.useActions();
  const isLoading = LoyaltyStoreAccess.useIsLoading();
  const variantCostSuffix = LoyaltyStoreAccess.useSuffix(variant.costInPoints);
  const dispatch = useSmartrrCustomerDispatch();

  const redeemVariant = async () => {
    const response = await actions.order.redeem.variant(variant);
    if (response.result === "success") {
      const info = response.data;
      if (info.orgPoints) {
        dispatch({
          type: "UPDATED_CUSTOMER_LOYALTY_POINTS",
          payload: {
            points: info.orgPoints,
          },
        } as CustomerAction<"UPDATED_CUSTOMER_LOYALTY_POINTS">);
      }
      if (info.updatedCPS) {
        dispatch({
          type: "UPDATE_CUSTOMER_PURCHASE_STATE",
          payload: {
            purchaseState: info.updatedCPS,
          },
        } as CustomerAction<"UPDATE_CUSTOMER_PURCHASE_STATE">);
      }
      upcomingOrder && toast(typedLocalize("loyalty.rewardRedeemed", { name: purchasableName }));
    } else {
      toast.error(response.message);
    }
    upcomingOrder && closeVariantModal();
  };

  return (
    <React.Fragment>
      <Stack alignItems="center" justifyContent="center" py="30px" spacing="10px">
        <Typography variant="h4">
          {typedLocalize("loyalty.redeemForPoints", {
            costInPoints: variant.costInPoints,
            unitName: variantCostSuffix,
          })}
        </Typography>
        <OrderVariantImage
          purchasableVariant={shopifyVariant}
          size="medium"
          className={prefixClassName("item-variant-image")}
        />
        <Typography variant="body1">
          {purchasableName} {typedLocalize("loyalty.willBeAdded")}
        </Typography>
        <Typography variant="body2">
          {typedLocalize("utils.dates.toViewDateLong", {
            date: upcomingOrder.date,
          })}
        </Typography>
      </Stack>
      <AquariusButtonGroup topBorder>
        <AquariusButton onClick={closeVariantModal} disabled={isLoading}>
          {typedLocalize("general.cancelBtn")}
        </AquariusButton>
        <AquariusButton filled onClick={async () => redeemVariant()} isLoading={isLoading}>
          {typedLocalize("general.confirmBtn")}
        </AquariusButton>
      </AquariusButtonGroup>
    </React.Fragment>
  );
};
